import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GlobalConstants } from '@globalConstants';
import { INote } from '@interfaces/INoteData';
import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import { ClearNoteAboutStudentErrors } from '@myStore/users-changes/users-changes.actions';
import { selectUsersChangesLoading } from '@myStore/users-changes/users-changes.selector';
import { GetUsersNotesRequest } from '@myStore/users-view/users-view.actions';
import {
  selectStudentNotes,
  selectStudentNotesLoading,
} from '@myStore/users-view/users-view.selector';
import { select, Store } from '@ngrx/store';
import { StudentNoteEditComponent } from '@shared/components/forms/student-note-edit/student-note-edit.component';
import { StudentNoteFormComponent } from '@shared/components/forms/student-note-form/student-note-form.component';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-student-note-view',
  templateUrl: './student-note-view.component.html',
  styleUrls: ['./student-note-view.component.sass'],
})
export class StudentNoteViewComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  readonly noteType = GlobalConstants.StudentsNoteTypes;

  public student: IUser | undefined;
  public type?: string;
  currentUserId$?: number;
  notes$: INote[] = [];
  public groupId?: number;
  public userNoteLoading$ = this._store.pipe(select(selectStudentNotesLoading));

  constructor(
    private _store: Store<IAppState>,
    private _dialog: MatDialog,
    public dialogRef: MatDialogRef<FormDialogComponent>
  ) {}

  ngOnInit(): void {
    const dialogData = this.dialogRef.componentInstance.data;
    this.student = dialogData.student;
    this.type = dialogData.type;
    this.currentUserId$ = dialogData.currentAuthUserId;
    this.groupId = dialogData.groupId;

    if (this.student) {
      this._store.dispatch(
        new GetUsersNotesRequest({
          student: this.student.id,
          type: 'esdp',
          writer: this.currentUserId$,
        })
      );
    }

    this._store
      .pipe(select(selectStudentNotes), takeUntil(this.destroy$))
      .subscribe(notes => {
        if (notes) {
          this.notes$ = notes;
        }
      });
  }

  onCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this._store.dispatch(new ClearNoteAboutStudentErrors());
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openAddNoteModal() {
    this.onCancel();

    this._dialog.open(FormDialogComponent, {
      width: '400px',
      data: {
        title: `Оставить заметку перед ESDP о ${this.student?.full_name}`,
        content: StudentNoteFormComponent,
        student: this.student,
        type: this.noteType.ESDP,
        groupId: this.groupId,
        loading$: this._store.pipe(select(selectUsersChangesLoading)),
      },
    });
  }

  editNoteAboutStudent() {
    this.onCancel();

    this._dialog.open(FormDialogComponent, {
      width: '400px',
      data: {
        title: `Редактировать заметку перед ESDP о ${this.student?.full_name}`,
        content: StudentNoteEditComponent,
        student: this.student,
        type: this.noteType.ESDP,
        groupId: this.groupId,
        note: this.notes$[0],
        loading$: this._store.pipe(select(selectUsersChangesLoading)),
      },
    });
  }
}
